import { get, post } from 'store/http/httpAction';
import moment from 'moment';
import Enums from 'utils/EnumsManager';
import { toUtc } from 'utils/dateTimeUtils';
import {
  DASHBOARD_SET_DATA,
  DASHBOARD_SET_TAG,
  DASHBOARD_SET_TODAY_DATA,
  SET_REPORT_OPTIONS,
  SET_SLOT_UPDATING,
  SET_ACTIVE_DASHBOARD,
  SET_REPORT_DASHBOARD_DATA,
  SET_ALL_REFRESHING,
  SET_SLOT_DATA,
  RESET_ACTIVE_DASHBOARD,
  RESET_DASHBOARD
} from './actionType';
import { mapOptionsToStore } from './utils';

const { ObjectTypes, DateTimeConfigs } = Enums;
const { Leads, Accounts, Opportunities } = ObjectTypes;
const { DefaultDateFormat } = DateTimeConfigs;

export const setData = data => ({
  type: DASHBOARD_SET_DATA,
  data,
});

export const settodayNewTotal = data => ({
  type: DASHBOARD_SET_TODAY_DATA,
  data,
});

export const setTagValue = value => ({
  type: DASHBOARD_SET_TAG,
  value,
});

const setReportOptions = options => ({
  type: SET_REPORT_OPTIONS,
  payload: { options },
});

export const setSlotUpdating = slotId => ({
  type: SET_SLOT_UPDATING,
  payload: { slotId },
});

export const setActiveDashboard = id => ({
  type: SET_ACTIVE_DASHBOARD,
  payload: { id },
});

export const resetActiveDashboard = () => ({
  type: RESET_ACTIVE_DASHBOARD,
});

export const setReportDashboardData = data => ({
  type: SET_REPORT_DASHBOARD_DATA,
  payload: { data },
});

export const setAllRefreshing = dashboardId => ({
  type: SET_ALL_REFRESHING,
  payload: { dashboardId },
});

export const reSetDashboard = () => ({
  type: RESET_DASHBOARD
});

const setSlotData = (updateSlotId, slotData) => ({
  type: SET_SLOT_DATA,
  payload: { updateSlotId, slotData },
});

export const fetchNewLeads = () => dispatch => get('/admin/leads/recent', {}, dispatch).then((data) => {
  dispatch(setData({
    leads: (data && data.data) || [],
  }));
});

export const fetchNewAccounts = () => dispatch => get('/admin/accounts/recent', {}, dispatch).then((data) => {
  dispatch(setData({
    accounts: (data && data.data) || [],
  }));
});

export const fetchLatestObject = () => dispatch => get('/admin/objects/recent-viewed', {}, dispatch).then((data) => {
  dispatch(setData({
    objects: (data && data.data) || [],
  }));
});

export const fetchLatestActivity = () => dispatch => get('/admin/tasks/me/not_start/limit/10/index', {}, dispatch).then((data) => {
  dispatch(setData({
    activities: (data && data.data) || [],
  }));
});

const fetchTodayTotal = (objectType, todayDate, tomorrowDate) => dispatch => get(`/admin/${objectType}?time_filter=created_at>=${todayDate};created_at<${tomorrowDate}`, {}, dispatch).then((data) => {
  dispatch(settodayNewTotal({
    [objectType]: data.index.meta.pagination.total,
  }));
});

export const fetchReportData = (dashboardId) => dispatch => get(`/admin/dashboard/${dashboardId}/with-data`, {}, dispatch).then((data) => {
  if (!_.isEmpty(data)) {
    dispatch(setReportDashboardData(data));
  }
});

const fetchReportOptions = (activeDashboard) => dispatch => get('/admin/dashboard/me/with-structure', {}, dispatch).then((data) => {
  if (!_.isEmpty(data)) {
    const options = mapOptionsToStore(data);
    if (_.isArray(options)) {
      dispatch(setReportOptions(options));
      // set default report dashboard if there is no one is selected.
      if (_.isEmpty(activeDashboard) && !_.isEmpty(options) && _.isArray(options[0].slots) && !_.isEmpty(options[0].slots[0])) {
        // the value of active dashboard id is expected string rather than number
        dispatch(setActiveDashboard(`${options[0].slots[0].id}`));
        dispatch(fetchReportData(options[0].slots[0].id));
      }
    }
  }
});

export const refreshReport = dashboardId => dispatch => post(`/admin/dashboard/${dashboardId}/refresh`, {}, dispatch).then((data) => {
  dispatch(setAllRefreshing(dashboardId));
});

export const refreshSlot = slotId => dispatch => post(`/admin/dashboard_slot/${slotId}/refresh`, {}, dispatch).then((data) => {
  dispatch(setSlotUpdating(slotId));
});

export const fetchSlotData = slotId => dispatch => get(`/admin/dashboard_slot/${slotId}/with-data`, {}, dispatch).then((data) => {
  if (!_.isEmpty(data)) {
    dispatch(setSlotData(slotId, data));
  }
});

export const fetchDashboardReportData = (activeDashboard) => (dispatch) => {
  if (!_.isEmpty(activeDashboard)) {
    dispatch(fetchReportData(activeDashboard));
  }
  dispatch(fetchReportOptions(activeDashboard));
};

export const fetchTodayNewTotal = () => (dispatch) => {
  const todayDate = toUtc(`${moment().format(DefaultDateFormat)} 00:00:00`, true);
  const tomorrowDate = toUtc(`${moment().add(1, 'days').format(DefaultDateFormat)} 00:00:00`, true);
  dispatch(fetchTodayTotal(Leads, todayDate, tomorrowDate));
  dispatch(fetchTodayTotal(Accounts, todayDate, tomorrowDate));
  dispatch(fetchTodayTotal(Opportunities, todayDate, tomorrowDate));
};




// WEBPACK FOOTER //
// ./src/views/Dashboard/flow/action.js